import { getMessages } from '../../../../../../../store/constants';

export const ASSIGNEES_SHARE_ID = '-1';
export const ASSIGNEES_SHARE_BUTTON = getMessages().getText('card_form_assignee_share');
export const ASSIGNEES_SEARCH_PLACEHOLDER = getMessages().getText('card_form_assigned_search_placeholder');
